export { SocialFacebook as default } from './SocialFacebook';
